import { render, staticRenderFns } from "./v-image.vue?vue&type=template&id=1c3f9262&scoped=true&"
import script from "./v-image.vue?vue&type=script&lang=js&"
export * from "./v-image.vue?vue&type=script&lang=js&"
import style0 from "./v-image.vue?vue&type=style&index=0&id=1c3f9262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f9262",
  null
  
)

export default component.exports